// Vendor imports
const Immutable = require('immutable')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class LinkModalRecord extends Immutable.Record({
  // Flags
    isLinkModalDismissed: Boolean()
}) {
  // No methods
}

LinkModalRecord.reviver = keyedReviver(LinkModalRecord, {
  // No nested data structures
})

module.exports = LinkModalRecord
